//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../../media/MediaQuery";

//css
import styled from "styled-components";
// component
import MyPageProduct from "../../../../component/content/MyPageProduct";
import Pagination from "../../../../component/pagination/Pagination";
import BasicBtn from "../../../../component/button/BasicBtn";
import DefaultPop from "../../../../component/popup/DefaultModal";

// responsive
import { M, T } from "../../../../utils/MT";

export default function MyPoint(props) {
    // 적립금 내역 리스트
    const [pointData, setPointData] = useState([]);

    // 천단위 콤마 추가
    function addComma(num) {
        let commaNum = num;
        commaNum = commaNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return commaNum;
    }

    const titleList = ["날짜", "상태", "내용", "내역", "잔액", "유효기간"];

    useEffect(() => {
        const PointList = [
            {
                date: "2021.12.23",
                state: "적립",
                content: "이벤트 적립",
                history: "+3000",
                balance: "5000",
                expired: "2022.12.23",
            },
            {
                date: "2021.12.23",
                state: "사용",
                content: "결제 시 사용",
                history: "-3000",
                balance: "2000",
                expired: "2022.12.23",
            },
            {
                date: "2021.12.23",
                state: "소멸",
                content: "적립금 유효기간 만료",
                history: "-1000",
                balance: "5000",
                expired: "2022.12.23",
            },
        ];
        setPointData(PointList);
    }, []);

    return (
        <Wrap>
            <MyPointSection>
                {/* 내 현재 적립금 */}
                <MyPointTitle>적립금</MyPointTitle>

                <MypointTable>
                    <MyPointTableList>
                        <MyPointTitleBox>
                            <MyPointListTitle>총 적립금</MyPointListTitle>
                            <MyListPoint>5,000</MyListPoint>
                        </MyPointTitleBox>
                        <MyPointTitleBox>
                            <MyPointListTitle>사용한 적립금</MyPointListTitle>
                            <MyListPoint>5,000</MyListPoint>
                        </MyPointTitleBox>
                        <MyPointTitleBox>
                            <MyPointListTitle>소멸된 적립금</MyPointListTitle>
                            <MyListPoint>5,000</MyListPoint>
                        </MyPointTitleBox>
                        <MyPointTitleBox>
                            <MyPointListTitle>잔여 적립금</MyPointListTitle>
                            <MyListPoint>5,000</MyListPoint>
                        </MyPointTitleBox>
                    </MyPointTableList>
                </MypointTable>

                {/* 내 적립금 내역 */}
                <MyPointHistoryTitle>적립금 내역</MyPointHistoryTitle>

                <MypointTable>
                    <PC>
                        <MyPointUseTitle>
                            <MyPointUseBox>날짜</MyPointUseBox>
                            <MyPointUseBox>상태</MyPointUseBox>
                            <MyPointUseBox>내용</MyPointUseBox>
                            <MyPointUseBox>내역</MyPointUseBox>
                            <MyPointUseBox>잔액</MyPointUseBox>
                            <MyPointUseBox>유효기간</MyPointUseBox>
                        </MyPointUseTitle>

                        <MyPointUseListWrap>
                            {/* 적립금 사용 내역이 없을 때 */}
                            {/* <NotPoint>적립금 사용 내역이 없습니다.</NotPoint> */}

                            {pointData.map((item, index) => {
                                return (
                                    <MyPointUseList key={"PointList" + index}>
                                        <MyPointUseBox>{item.date}</MyPointUseBox>
                                        <MyPointUseBox>{item.state}</MyPointUseBox>
                                        <MyPointUseBox>{item.content}</MyPointUseBox>
                                        <MyPointUseBox style={{ color: item.history > 0 ? "var(--main-color)" : "#aaa" }}>
                                            {addComma(item.history)}
                                        </MyPointUseBox>
                                        <MyPointUseBox>{addComma(item.balance)}</MyPointUseBox>
                                        <MyPointUseBox>{item.expired}</MyPointUseBox>
                                    </MyPointUseList>
                                );
                            })}
                        </MyPointUseListWrap>
                    </PC>

                    <Mobile>
                        <MyPointUseListWrap>
                            {/* 적립금 사용 내역이 없을 때 */}
                            {/* <NotPoint>적립금 사용 내역이 없습니다.</NotPoint> */}

                            {pointData.map((item, index) => {
                                return (
                                    <MyPointUseList key={"PointList" + index}>
                                        <MbMyPointUseTitleWrap>
                                            {titleList.map((value, idx) => {
                                                return <MbPointUseTitle key={idx}>{value}</MbPointUseTitle>;
                                            })}
                                        </MbMyPointUseTitleWrap>

                                        <MbPointUseBoxWrap>
                                            <MbMyPointUseBox>{item.date}</MbMyPointUseBox>
                                            <MbMyPointUseBox>{item.state}</MbMyPointUseBox>
                                            <MbMyPointUseBox>{item.content}</MbMyPointUseBox>
                                            <MbMyPointUseBox style={{ color: item.history > 0 ? "var(--main-color)" : "#aaa" }}>
                                                {addComma(item.history)}
                                            </MbMyPointUseBox>
                                            <MbMyPointUseBox>{addComma(item.balance)}</MbMyPointUseBox>
                                            <MbMyPointUseBox>{item.expired}</MbMyPointUseBox>
                                        </MbPointUseBoxWrap>
                                    </MyPointUseList>
                                );
                            })}
                        </MyPointUseListWrap>
                    </Mobile>
                </MypointTable>

                {/* 페이징 */}
                <Paging>
                    <Pagination />
                </Paging>
            </MyPointSection>
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto;
    }
`;

const MyPointSection = styled.div``;

const MyPointTitle = styled.h2`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;

const MyPointHistoryTitle = styled(MyPointTitle)`
    margin-top: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(50)};
    }
`;

const MypointTable = styled.div``;

const MyPointTableList = styled.ul`
    display: flex;
    margin-top: calc(100vw * (20 / 1920));

    border-top: 1px solid #222;
    border-bottom: 1px solid #dddddd;

    & li {
        width: calc(100vw * (210 / 1920));
    }

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (20 / 1300));

        & li {
            width: calc(100vw * (210 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        flex-wrap: wrap;
        margin-top: ${M(20)};

        & li {
            width: ${M(189)};
        }
    }
`;

const MyPointTitleBox = styled.li`
    font-size: calc(100vw * (15 / 1920));

    text-align: center;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};
    }
`;
const MyPointListTitle = styled.p`
    padding: 20px 0;
    background: #fafafa;
    border-bottom: 1px solid #e5e5e5;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        padding: ${M(20)} 0;
    }
`;
const MyListPoint = styled.p`
    padding: 20px 0;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        padding: ${M(20)} 0;
    }
`;
const MyPointBox = styled(MyPointTableList)`
    border-top: none;
    margin-top: 0;
`;

const MyPointUseTitle = styled(MyPointTableList)`
    background: #fafafa;
    padding: calc(100vw * (20 / 1920)) 0;

    & li:nth-child(1) {
        width: calc(100vw * (105 / 1920));
    }
    & li:nth-child(2) {
        width: calc(100vw * (85 / 1920));
    }
    & li:nth-child(3) {
        width: calc(100vw * (330 / 1920));
    }
    & li:nth-child(4) {
        width: calc(100vw * (100 / 1920));
    }
    & li:nth-child(5) {
        width: calc(100vw * (115 / 1920));
    }
    & li:nth-child(6) {
        width: calc(100vw * (105 / 1920));
    }

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;

        & li:nth-child(1) {
            width: calc(100vw * (105 / 1300));
        }
        & li:nth-child(2) {
            width: calc(100vw * (85 / 1300));
        }
        & li:nth-child(3) {
            width: calc(100vw * (330 / 1300));
        }
        & li:nth-child(4) {
            width: calc(100vw * (100 / 1300));
        }
        & li:nth-child(5) {
            width: calc(100vw * (115 / 1300));
        }
        & li:nth-child(6) {
            width: calc(100vw * (105 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        padding: ${M(20)} 0;

        & li:nth-child(1) {
            width: ${M(105)};
        }
        & li:nth-child(2) {
            width: ${M(85)};
        }
        & li:nth-child(3) {
            width: ${M(330)};
        }
        & li:nth-child(4) {
            width: ${M(100)};
        }
        & li:nth-child(5) {
            width: ${M(115)};
        }
        & li:nth-child(6) {
            width: ${M(105)};
        }
    }
`;

const MyPointUseList = styled(MyPointUseTitle)`
    background: #fff;
    border-top: none;
    padding: calc(100vw * (20 / 1920)) 0;
    margin-top: 0;

    & li:nth-child(2) {
        color: var(--main-color);
    }
    & li:nth-child(4) {
        /* color: var(--main-color); */
    }
    & li:nth-child(5) {
        color: var(--main-color);
    }
    & li:nth-child(6) {
        color: #aaaaaa;
    }

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        justify-content: space-between;
        padding: ${M(20)} 0;
    }
`;

const MyPointUseBox = styled(MyPointTitleBox)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const Paging = styled.div`
    margin-top: calc(100vw * (60 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (60 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(60)};
    }
`;

const MyPointUseListWrap = styled.div`
    @media screen and (max-width: 900px) {
        margin-top: ${M(20)};
        border-top: 1px solid #000000;
    }
`;

const NotPoint = styled.p`
    margin: calc(100vw * (100 / 1920)) 0;

    font-size: calc(100vw * (14 / 1920));
    color: #909090;
    text-align: center;

    @media screen and (max-width: 1300px) {
        margin: calc(100vw * (100 / 1300));
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin: ${M(160)} auto;
        font-size: ${M(14)};
    }
`;
const MbPointUseBoxWrap = styled.li`
    & p:nth-child(2) {
        color: var(--main-color);
    }
    & p:nth-child(5) {
        color: var(--main-color);
    }
    & p:nth-child(6) {
        color: #aaaaaa;
    }
`;
const MbMyPointUseTitleWrap = styled.li``;
const MbPointUseTitle = styled.p`
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-bottom: ${M(10)};
        font-size: ${M(15)};
    }
`;
const MbMyPointUseBox = styled.p`
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-bottom: ${M(10)};
        font-size: ${M(15)};
        text-align: right;
    }
`;
